import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { BpUnavailableContent, ModalOverlay } from './styles';

export interface BpUnavailableModalProps {
  onCloseModal: () => void;
  title?: string;
  message?: string;
}

export const BpUnavailableModal = ({
  onCloseModal,
  title = 'Emissor não habilitado para comprar aços longos',
  message = 'O emissor selecionado não está habilitado para comprar aços longos. Caso tenha interesse, entre em contato com seu vendedor.'
}: BpUnavailableModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  return (
    <ModalOverlay>
      <Modal
        title={title}
        modalSize="sm"
        onClose={onCloseModal}
        buttons={{
          right: {
            name: 'button-close-bp-unavailable',
            children: 'Fechar',
            onClick: onCloseModal,
            type: 'button'
          }
        }}
      >
        <BpUnavailableContent>
          <div>{message}</div>
        </BpUnavailableContent>
      </Modal>
    </ModalOverlay>
  );
};
